"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnumInvoiceLineType;
(function (EnumInvoiceLineType) {
    EnumInvoiceLineType["PREMIUM"] = "PREMIUM";
    EnumInvoiceLineType["IPT_TAX"] = "IPT_TAX";
    EnumInvoiceLineType["REFUND"] = "REFUND";
    EnumInvoiceLineType["INTEREST"] = "INTEREST";
    EnumInvoiceLineType["CANCELLATION_FEE"] = "CANCELLATION_FEE";
})(EnumInvoiceLineType || (EnumInvoiceLineType = {}));
exports.default = EnumInvoiceLineType;
//# sourceMappingURL=EnumInvoiceLineType.js.map